import * as React from 'react';
import { IOffer } from '../../types/offer';
import { IComplaintsHelpers } from '../../types/complaints';
import { IOfferCardComponentsProps } from '../../offer-card';
import { SlonoTopFooter } from './slonoTopFooter';

interface ISlonoTopFooterProps {
  currentPath: string | undefined;
  suggestionDistancesSeoText: string | undefined;
  complaintsHelpers: IComplaintsHelpers;
  position: number;
  agentPhone: string | undefined;
  isPhoneHidden: boolean;
  isSimilar: boolean;
  offer: IOffer;
  api: IOfferCardComponentsProps;
  currentSubdomain: string;
  qsToUris?: { [key: string]: string; };
  isOnHideAnimation?: boolean;
  isHideOfferFetching?: boolean;

  toggleCallbackModal(): void;

  handleHideFromPrintClick(): void;

  onDescriptionClick(evt: MouseEvent): void;

  handleTitleClick(e: React.MouseEvent<HTMLAnchorElement>): void;

  onFavoriteChange(isFavorite: boolean): void;
}

interface ISlonotopFooterState {
  isCommentAreaOpened: boolean;
  isMapActive: boolean;
  isMapLoaded: boolean;
  isComplainOpen: boolean;
}

export class SlonoTopFooterContainer extends React.Component<ISlonoTopFooterProps, ISlonotopFooterState> {

  public state = {
    isComplainOpen: false,
    isCommentAreaOpened: false,
    isMapActive: false,
    isMapLoaded: false,
  };

  public render() {
    return (
      <SlonoTopFooter
        { ...this.props }
        { ...this.state }
        handleCommentingCompletion={ this.handleCommentingCompletion }
        handleCommentClick={ this.handleCommentClick }
        handleButtonMapClick={ this.handleButtonMapClick }
        onComplainClose={ this.onComplainClose }
      />
    );
  }

  private handleCommentingCompletion = () => {
    if (!this.state.isCommentAreaOpened) {
      return;
    }

    this.setState({
      isCommentAreaOpened: false,
    });
  }

  private handleCommentClick = () => {
    if (this.state.isCommentAreaOpened) {
      return;
    }

    this.setState({
      isCommentAreaOpened: true,
    });
  }

  private handleButtonMapClick = () => {

    this.setState({
      isMapActive: !this.state.isMapActive,
      isMapLoaded: true,
    });
  }

  private onComplainClose = () => {
    this.setState({ isComplainOpen: false });
  }
}
